import React from 'react';
import { Link } from 'react-router-dom';
import PictureDetails from './PictureDetails';
import Details from './Details';

const ListingPage = ({ therapist }) => {
  return (
    <>
      <Link
        to={`/therapists/${therapist.profileLink}`}
        style={{ textDecoration: 'none', color: 'inherit' }}>
        <div className="therapist-container margin-top--md">
          {therapist?.badge && (
            <div className="badge-container flex-container justify-between align-center">
              <p style={{ fontWeight: '500' }}>
                {therapist?.badge?.text
                  ? therapist.badge.text.length > 23
                    ? therapist.badge.text.slice(0, 23) + '...'
                    : therapist.badge.text
                  : ''}
              </p>
              {therapist?.badge?.logo && (
                <img
                  src={therapist.badge.logo}
                  alt="Logo"
                  style={{ maxWidth: '80px', height: '50px', objectFit: 'contain' }}
                />
              )}
            </div>
          )}
          <div className="listing-div flex-container">
            <div className="image-outer-div flex-container">
              <PictureDetails therapist={therapist} />
            </div>
            <div className="details-div">
              <Details therapist={therapist} />
            </div>
          </div>
        </div>
      </Link>
      <style jsx>
        {`
          .therapist-container {
            border-radius: 10px;
            border: 1px solid lightgrey;
            overflow: hidden;
          }
          .listing-div {
            display: flex;
            padding: 15px;
            // justify-content: space-evenly;
          }
          .listing-div:hover {
            background-color: #f4f4f4;
            border-radius: 5px;
          }
          .badge-container {
            min-height: 50px;
            padding: 5px 16px;
            background-color: #facc02;
          }
          .image-outer-div {
            display: flex;
            justify-content: center;
            align-items: center;
            // padding-left: 10px;
            // width: 20%;
          }

          .details-div {
            // width: 60%;
            padding: 10px;
            margin-left: 10px;
            flex: 1;
          }

          @media only screen and (max-width: 760px) {
            .listing-div {
              flex-direction: column;
              padding: 10px;
            }
            .details-div {
              margin-left: 0px;
            }
          }
          @media only screen and (max-width: 500px) {
            .image-outer-div {
              justify-content: start;
              padding-left: 10px;
            }
          }
        `}
      </style>
    </>
  );
};

export default ListingPage;
